export default __webpack_public_path__ + "static/tftPenguinSmall-726ad5b7ae765ddcc2ca8f01cff79443.webp";